export const UNIT_CODE_OPTIONS = [
  // Barang
  { value: "UM.0001", label: "UM.0001 - Ampere", group: "goods" },
  { value: "UM.0002", label: "UM.0002 - Barrel", group: "goods" },
  { value: "UM.0003", label: "UM.0003 - Boks", group: "goods" },
  { value: "UM.0004", label: "UM.0004 - Drum", group: "goods" },
  { value: "UM.0005", label: "UM.0005 - Gram", group: "goods" },
  { value: "UM.0006", label: "UM.0006 - Inci", group: "goods" },
  { value: "UM.0007", label: "UM.0007 - Karat", group: "goods" },
  { value: "UM.0008", label: "UM.0008 - Karton", group: "goods" },
  { value: "UM.0009", label: "UM.0009 - Kilogram", group: "goods" },
  { value: "UM.0010", label: "UM.0010 - Kiloliter", group: "goods" },
  { value: "UM.0011", label: "UM.0011 - Lainnya", group: "goods" },
  { value: "UM.0012", label: "UM.0012 - Lembar", group: "goods" },
  { value: "UM.0013", label: "UM.0013 - Liter", group: "goods" },
  { value: "UM.0014", label: "UM.0014 - Lusin", group: "goods" },
  { value: "UM.0015", label: "UM.0015 - MMBTU", group: "goods" },
  { value: "UM.0016", label: "UM.0016 - Meter", group: "goods" },
  { value: "UM.0017", label: "UM.0017 - Meter Persegi", group: "goods" },
  { value: "UM.0018", label: "UM.0018 - Metrik Ton", group: "goods" },
  { value: "UM.0019", label: "UM.0019 - Piece", group: "goods" },
  { value: "UM.0020", label: "UM.0020 - Sentimeter", group: "goods" },
  { value: "UM.0021", label: "UM.0021 - Sentimeter Kubik", group: "goods" },
  { value: "UM.0022", label: "UM.0022 - Set", group: "goods" },
  { value: "UM.0023", label: "UM.0023 - Unit", group: "goods" },
  { value: "UM.0024", label: "UM.0024 - Wet Ton", group: "goods" },
  { value: "UM.0025", label: "UM.0025 - Yard", group: "goods" },
  // Jasa
  { value: "UM.0026", label: "UM.0026 - Bahan", group: "services" },
  { value: "UM.0027", label: "UM.0027 - Bulan", group: "services" },
  { value: "UM.0028", label: "UM.0028 - Hari", group: "services" },
  { value: "UM.0029", label: "UM.0029 - Jam", group: "services" },
  { value: "UM.0030", label: "UM.0030 - Kegiatan", group: "services" },
  { value: "UM.0031", label: "UM.0031 - Lainnya", group: "services" },
  { value: "UM.0032", label: "UM.0032 - Laporan", group: "services" },
  { value: "UM.0033", label: "UM.0033 - Menit", group: "services" },
  { value: "UM.0034", label: "UM.0034 - Minggu", group: "services" },
  { value: "UM.0035", label: "UM.0035 - Persen", group: "services" },
  { value: "UM.0036", label: "UM.0036 - Tahun", group: "services" },
];
